type RouteLoadingFallbackProps = {
  title?: string;
  description?: string;
};

const RouteLoadingSpinner = () => (
  <svg
    className="h-8 w-8 animate-spin text-amber-400"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
  >
    <circle
      cx="12"
      cy="12"
      r="9"
      stroke="currentColor"
      strokeOpacity="0.25"
      strokeWidth="3"
    />
    <path
      d="M21 12a9 9 0 0 0-9-9"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export const RouteLoadingFallback = ({
  title = "Loading application",
  description = "Preparing your workspace…",
}: RouteLoadingFallbackProps) => (
  <div
    className="flex min-h-screen items-center justify-center bg-[#060b15] px-6 text-white"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <div className="flex w-full max-w-sm flex-col items-center gap-5 text-center">
      <RouteLoadingSpinner />
      <div className="space-y-2">
        <p className="text-base font-semibold tracking-tight text-white">{title}</p>
        <p className="text-sm text-[#99A1AA]">{description}</p>
      </div>
      <div className="h-1 w-full overflow-hidden rounded-full bg-white/10">
        <div className="h-full w-1/3 animate-pulse rounded-full bg-amber-400/80" />
      </div>
    </div>
  </div>
);
